import { derived, writable } from "svelte/store"
import { deepMerge } from "@/libs/lodash"

export type NestedDictionary = {
  [key: string]: string | NestedDictionary
}

/** @returns Svelte store to access */
export const create = <T extends NestedDictionary>(messages: T) => {
  const messagesStore = writable(messages)

  const defaultNamespace = writable("")

  // This store helps to extend/override the default messages with a new custom messages
  // Needs to have different messages for “front” and “back” camera use cases
  const { subscribe } = derived(
    [messagesStore, defaultNamespace],
    ([$messagesStore, $defaultNamespace]): T => {
      if (
        $defaultNamespace &&
        $messagesStore[$defaultNamespace] &&
        typeof $messagesStore[$defaultNamespace] === "object"
      )
        return deepMerge(
          {},
          $messagesStore,
          $messagesStore[$defaultNamespace] as Record<string, NestedDictionary>,
        )

      return $messagesStore
    },
  )

  const add = <T extends NestedDictionary>(messages: T) =>
    messagesStore.update((s) => deepMerge({}, s, messages))

  const setDefaultNamespace = (namespace: string) => defaultNamespace.set(namespace)

  return { subscribe, add, setDefaultNamespace }
}
